import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@primitives/button";
import { getEmail } from "@/server/services/emailService";

interface Props {
  onContinue: () => void;
}

export default function CurrentEmailStep({ onContinue }: Props) {
  const { t } = useTranslation();
  const [maskedEmail, setMaskedEmail] = useState<string | null | undefined>(
    undefined,
  );
  const [error, setError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setError(false);
    setMaskedEmail(undefined);
    getEmail()
      .then((data) => {
        if (!cancelled) {
          setMaskedEmail(data.email);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [retryCount]);

  return (
    <div className="my-7 space-y-4">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold">{t("changeEmail.title")}</h2>
        <p className="text-sm text-muted-foreground">
          {t("changeEmail.description")}
        </p>
      </div>

      <div className="rounded-lg border border-border bg-card px-4 py-3 text-sm">
        <p className="text-xs text-muted-foreground">
          {t("changeEmail.currentEmail")}
        </p>
        <p className="mt-1">
          {maskedEmail === undefined && !error ? (
            <span className="text-muted-foreground">{t("loading")}…</span>
          ) : error ? (
            <span className="text-destructive">{t("errorOccurred")}</span>
          ) : (
            <span className="text-foreground">
              {maskedEmail ?? t("changeEmail.noEmail")}
            </span>
          )}
        </p>
      </div>

      {error ? (
        <Button
          className="h-12 w-full rounded-lg"
          onClick={() => setRetryCount((c) => c + 1)}
        >
          {t("errorBoundary.tryAgain")}
        </Button>
      ) : (
        <Button
          className="h-12 w-full rounded-lg"
          disabled={maskedEmail === undefined}
          onClick={onContinue}
        >
          {t("register.emailStep.continueButton")}
        </Button>
      )}
    </div>
  );
}
